<div class="page-header-container">
  <div class="page-header-content">
    <md-page-header [title]="'NAV.BYPRODUCTS' | translate" icon="product"></md-page-header>
    <mat-form-field class="page-header-right-column no-subscript">
      <mat-label>{{ 'SEARCH.PRODUCTS.BYPRODUCTS' | translate }}</mat-label>
      <input matInput type="text" [formControl]="searchInput" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>

<div class="grid-container">
  <div class="grid-header-container">
    <div class="grid-header-actions">
      <button mat-flat-button color="primary" (click)="exportToExcel()" [disabled]="isExporting()">
        <mat-icon>file_download</mat-icon>
        {{ 'COMMON.EXPORT_EXCEL' | translate }}
      </button>
    </div>
  </div>

  <ag-grid-angular
    class="ag-theme-alpine"
    [rowData]="displayProducts()"
    [columnDefs]="columnDefs()"
    [domLayout]="'autoHeight'"
    [pagination]="true"
    (gridReady)="onGridReady($event)"
    (rowClicked)="rowOnClick($event)"
  ></ag-grid-angular>
</div>
